import Immutable from 'immutable';
import memoize from 'fast-memoize';
import webapi, {REPORTED_EXCEPTION} from '../webapi';

let restLookupMap = {};

function getRestLookup(getTextUri, getRowsUri, processFilter, fixedParams, supportsCombo) {
	const key = getTextUri + '$$' + getRowsUri + '$$' + JSON.stringify(fixedParams);
	let res = restLookupMap[key];
	if (!res) {
		res = new RestLookup(getTextUri, getRowsUri, processFilter, fixedParams, supportsCombo);
		restLookupMap[key] = res;
	}
	return res;
}

const identity = (value) => value;

export default function RestLookup(getTextUri, getRowsUri, processFilter, fixedParams, supportsCombo) {
	if (!(this instanceof RestLookup)) {
		return getRestLookup(getTextUri, getRowsUri, processFilter, fixedParams, supportsCombo)
	}

	processFilter = processFilter || identity;

	let _isRunning = false;
	let _requestedFilter = null;


	let textBundleTimeoutId = null;
	let textBundle = [];

	this.supportsCombo = supportsCombo;


	const processParams = function(params) {
		var pars = Object.assign({}, params);
		if (fixedParams) {
			for (let name in fixedParams) {
				const fp = fixedParams[name];
				if (typeof fp === 'function') {
					pars[name] = fp();
				} else {
					pars[name] = fp;
				}
			}
		}
		return pars;
	};

	this.getMultiText = async function(keys) {
		const res = await webapi.execute(getTextUri, {keys}, null, true);
		let resMap = {};
		res.forEach(item => {
			resMap[item.key] = item.text;
		});
		return resMap;
	};

	const callGetText = async function (key) {
		let _resolve;
		const res = new Promise(function(resolve) {
			_resolve = resolve;
		});
		textBundle.push({
			key,
			_resolve
		});
		if (!textBundleTimeoutId) {
			textBundleTimeoutId = window.setTimeout(async () => {
				let localBundle = textBundle;
				textBundleTimeoutId = null;
				textBundle = [];
				let allKeys = localBundle.map(lb => lb.key);
				const res = await webapi.execute(getTextUri, {keys: allKeys}, null, true);
				let resMap = {};
				res.forEach(item => {
					resMap[item.key] = item.text;
				});
				localBundle.forEach(lb => {
					lb._resolve(resMap[lb.key] || null);
				})
			}, 0);
		}
		return res;
	};

	const getTextInternal = memoize(async function(gti, key) {
		return await callGetText(key);
	}, {
		cacheLimit: 1000
	});

	this.getText = async function(key) {
		if (key === null || key === undefined) {
			return null;
		}
		return getTextInternal(getTextUri, key);
	};

	const search = async function(filter) {
		filter = filter || '';
		const filterLen = filter.length;
		let pars = processParams({filter: processFilter(filter, filterLen > 0)});
		pars.filterNum = parseInt(pars.filter);
		let res = await webapi.execute(getRowsUri, pars, null, true);
		if (res === REPORTED_EXCEPTION) {
			return [];
		} else {
			return res;
		}
	};

	this.getTimeout = function() {
		return 500;
	};

	this.getRows = async function(filter) {
		const filterLen = (filter || '').trim().length;
		if (_isRunning) {
			_requestedFilter = filter;
			return null;
		}
		_isRunning = true;
		let res = await search(filter);
		while (_requestedFilter) {
			filter = _requestedFilter;
			_requestedFilter = null;
			res = await search(filter);
		}
		_isRunning = false;
		return Immutable.fromJS(res);
	};

	this.withFixedParams = function(fixedParams) {
		return getRestLookup(getTextUri, getRowsUri, processFilter, fixedParams, supportsCombo)
	};
}

